import { OtDataDrivenDefinition } from '@/wf-components/models/data-driven-definition';
import json from './additional-information-dialog-example-definition.json';

export const AdditionalInformationDialogExampleDefinition = OtDataDrivenDefinition.createFromJson(json as never);

export default AdditionalInformationDialogExampleDefinition;
